(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.Events.EventView.Details",
                    {
                        url: "/Details",
                        component: "eventDetails",
                        PageTitle: "Event Details | Marketing Tracker"
                    });
        }
    ]);

    app
        .component("eventDetails",
            {
                templateUrl: "App/Tools/MarketingTrackerNew/Events/EventView/EventDetails/eventdetails-template.html",
                controller: eventDetailsController,
                bindings: {
                }
            });

    eventDetailsController.$inject = ["marketingTrackerEventApi", "$q", "$stateParams", "marketingTrackerEventGroupApi", "$timeout", "figToaster", "marketingTrackerEventBuyingUnitApi", "featureToggleService", "marketingTrackerSalesTrackerInputApi", "$mdDialog"];
    function eventDetailsController(marketingTrackerEventApi, $q, $stateParams, marketingTrackerEventGroupApi, $timeout, figToaster, marketingTrackerEventBuyingUnitApi, featureToggleService, marketingTrackerSalesTrackerInputApi, $mdDialog) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {
                    saving: false,
                    hideContent: false,
                    disableContent: false
                },
                openMenu: openMenu,
                stats: {},
                update: update,
                calcStats: calcStats,
                hasSaved: false,
                showSavedMessage: showSavedMessage,
                checkChanged: checkChanged,
                saveViaKeyboard: saveViaKeyboard,
            });

        function openMenu($mdMenu, ev) {
            originatorEv = ev;
            $mdMenu.open(ev);
        }
        function checkChanged() {

            if (!ng.equals($ctrl.eventGroup, $ctrl.eventGroupCopy) || !ng.equals($ctrl.event, $ctrl.eventCopy))
                return false;
            else return true;

        }

        function showSavedMessage() {
            $ctrl.hasSaved = true;
            $timeout(function () {
                $ctrl.hasSaved = false;
            }, 3000);
        }

        function update() {
            var message = "", toastClass = "";
            $ctrl.ui.saving = true;
            marketingTrackerEventGroupApi.update($ctrl.eventGroup.Id, $ctrl.eventGroup)
                .then(function () {
                    var promises = [];

                    if (!!$ctrl.eventGroup.Reservations)
                        promises.push(marketingTrackerEventGroupApi.updateReservations($ctrl.eventGroup.Id, $ctrl.eventGroup));

                    if (!!$ctrl.eventGroup.Attendees)
                        promises.push(marketingTrackerEventGroupApi.updateAttendees($ctrl.eventGroup.Id, $ctrl.eventGroup));

                    if (!!$ctrl.eventGroup.UnitsAttended)
                        promises.push(marketingTrackerEventGroupApi.updateUnitsAttended($ctrl.eventGroup.Id, $ctrl.eventGroup));

                    if (!!$ctrl.eventGroup.AppointmentsSet)
                        promises.push(marketingTrackerEventGroupApi.updateAppointmentsSet($ctrl.eventGroup.Id, $ctrl.eventGroup));

                    if (!!$ctrl.eventGroup.AppointmentsKept)
                        promises.push(marketingTrackerEventGroupApi.updateAppointmentsKept($ctrl.eventGroup.Id, $ctrl.eventGroup));

                    if (!!$ctrl.eventGroup.AppointmentsClosed)
                        promises.push(marketingTrackerEventGroupApi.updateAppointmentsClosed($ctrl.eventGroup.Id, $ctrl.eventGroup));

                    $q.all(promises)
                        .then(function () {
                            marketingTrackerEventGroupApi.updateEvent($ctrl.eventGroup.Id, $ctrl.event.Id, $ctrl.event)
                                .then(function () {
                                    //$ctrl.ui.saving = false;
                                    $ctrl.eventCopy = ng.copy($ctrl.event);
                                    $ctrl.eventGroupCopy = ng.copy($ctrl.eventGroup);
                                    showSavedMessage();
                                });
                        })
                        .catch(function (error) {
                            console.log("Update error:" + error.data);
                        });
                    message = "Changes saved.";
                    toastClass = "is-success";
                })
                .catch(function (error) {
                    console.log("Error: " + error.data);
                    message = "There was a problem updating your data. Please try again shortly.";
                    toastClass = "is-error";
                })
                .finally(function () {
                    $ctrl.ui.isUploading = false;
                    $ctrl.ui.saving = false;
                    return figToaster.showSimple(message, "top", toastClass);
                });
        }

        function calcStats() {
            var clientEventTypes = [
                "Client Appreciation Events", "Client Educational Events",
                "Social Events", "Holiday Events", "Referral Events"
            ];

            $ctrl.stats = {
                responseRate: 0,
                noShowRate: 0,
                appointmentSettingRate: 0,
                persistencyRate: 0,
                closeRate: 0,
                roi: 0
            };

            var totalReservations = $ctrl.eventGroup.Reservations ? ($ctrl.eventGroup.Reservations.Prospects || 0) +
                ($ctrl.eventGroup.Reservations.Referrals || 0) +
                ($ctrl.eventGroup.Reservations.Clients || 0) : 0;
            var totalAttendees = $ctrl.eventGroup.Attendees ? ($ctrl.eventGroup.Attendees.Prospects || 0) +
                ($ctrl.eventGroup.Attendees.Referrals || 0) +
                ($ctrl.eventGroup.Attendees.Clients || 0) : 0;
            var totalUnitsAttended = $ctrl.eventGroup.UnitsAttended ? ($ctrl.eventGroup.UnitsAttended.Prospects || 0) +
                ($ctrl.eventGroup.UnitsAttended.Referrals || 0) +
                ($ctrl.eventGroup.UnitsAttended.Clients || 0) : 0;
            var totalAppointmentsSet = $ctrl.eventGroup.AppointmentsSet ? ($ctrl.eventGroup.AppointmentsSet.Prospects || 0) +
                ($ctrl.eventGroup.AppointmentsSet.Referrals || 0) +
                ($ctrl.eventGroup.AppointmentsSet.Clients || 0) : 0;
            var totalAppointmentsKept = $ctrl.eventGroup.AppointmentsKept ? ($ctrl.eventGroup.AppointmentsKept.Prospects || 0) +
                ($ctrl.eventGroup.AppointmentsKept.Referrals || 0) +
                ($ctrl.eventGroup.AppointmentsKept.Clients || 0) : 0;
            var totalAppointmentsClosed = $ctrl.eventGroup.AppointmentsClosed ? ($ctrl.eventGroup.AppointmentsClosed.Prospects || 0) +
                ($ctrl.eventGroup.AppointmentsClosed.Referrals || 0) +
                ($ctrl.eventGroup.AppointmentsClosed.Clients || 0) : 0;

            if ($ctrl.eventGroup.Reservations && $ctrl.eventGroup.Invites > 0) {
                if (_.find(clientEventTypes, function (row) { return row === $ctrl.eventGroup.EventType.Name; })) {
                    $ctrl.stats.responseRate = totalReservations / $ctrl.eventGroup.Invites;
                } else {
                    $ctrl.stats.responseRate = $ctrl.eventGroup.Reservations.Prospects / $ctrl.eventGroup.Invites;
                }
            }
            if ($ctrl.eventGroup.Reservations && $ctrl.eventGroup.Attendees && totalReservations > 0) {
                $ctrl.stats.noShowRate = (totalReservations - totalAttendees) / totalReservations;
            }
            if ($ctrl.eventGroup.UnitsAttended && $ctrl.eventGroup.AppointmentsSet && totalUnitsAttended > 0) {
                $ctrl.stats.appointmentSettingRate = totalAppointmentsSet / totalUnitsAttended;
            }
            if ($ctrl.eventGroup.AppointmentsKept && $ctrl.eventGroup.AppointmentsSet && totalAppointmentsSet > 0) {
                $ctrl.stats.persistencyRate = totalAppointmentsKept / totalAppointmentsSet;
            }
            if ($ctrl.eventGroup.AppointmentsClosed && $ctrl.eventGroup.AppointmentsKept && totalAppointmentsKept > 0) {
                $ctrl.stats.closeRate = totalAppointmentsClosed / totalAppointmentsKept;
            }
            if ($ctrl.eventGroup.TotalEventCost > 0) {
                $ctrl.stats.roi = (($ctrl.eventGroup.TotalCommission || 0) - $ctrl.eventGroup.TotalEventCost) /
                    $ctrl.eventGroup.TotalEventCost;
            }
        }

        $ctrl.openAddSpendingFromEventModal = function () {
            $mdDialog.show(
                {
                    controller: "addSpendingController",
                    controllerAs: "$ctrl",
                    templateUrl: "App/Tools/MarketingTrackerNew/Components/AddSpending/add-spending.component.html",
                    bindToController: true,
                    eventName: $ctrl.event.Title,
                    eventCost: $ctrl.eventGroup.TotalEventCost,
                    eventDate: $ctrl.allEvents[0].EventDate,
                    eventGroupId: $ctrl.eventGroup.Id,
                    ancillaryEventGroupId: null
                })
                .then(function (spending) {
                    $ctrl.spending = spending;
                })
        }

        function saveViaKeyboard($event) {
            if (event.ctrlKey && event.keyCode === 83) {
                event.preventDefault();
                update();
            }
        }

        $ctrl.$onInit = function () {
            var promises = [];

            $ctrl.toggleFeature = featureToggleService.checkEnv();
            //Run this check to see if user has already uploaded a responder list in event details V2. If so, hide the content of this page to avoid conflicts
            //TODO: Reroute user to event details V2 instead once the feature goes live
            marketingTrackerEventBuyingUnitApi.getBuyingUnits($stateParams.EventGroupId).then(function (response) {
                if (response.length) {
                    //$ctrl.ui.hideContent = true;
                    $ctrl.ui.disableContent = true;
                } 

                promises.push(marketingTrackerEventApi.getEvent($stateParams.EventGroupId, $stateParams.EventId).then(function (response) {
                    $ctrl.event = response;
                    $ctrl.event.EventDate = new Date($ctrl.event.EventDate);
                    $ctrl.eventCopy = ng.copy($ctrl.event);
                }));
                promises.push(marketingTrackerEventApi.getEventGroup($stateParams.EventGroupId).then(function (response) {
                    $ctrl.eventGroup = response;
                    $ctrl.eventGroupCopy = ng.copy($ctrl.eventGroup);
                }));
                promises.push(marketingTrackerEventGroupApi.getEvents($stateParams.EventGroupId).then(function (response) {
                    $ctrl.allEvents = response.sort(function (a, b) {
                        return a.EventDate.localeCompare(b.EventDate);
                    });
                }))
                promises.push(marketingTrackerSalesTrackerInputApi.getSpendingByEventGroupId($stateParams.EventGroupId).then(function (response) {
                    console.log(response);
                    $ctrl.spending = response;
                }));
                $q.all(promises).then(function (response) {
                    calcStats();
                });
            });

        };
    }

})(window.app, window.angular); //jshint ignore:line